import { useMemo } from 'react';
import { tv } from 'tailwind-variants';
import { Button } from '@/shared/components/ui/button';
import { applyAmountPrecision } from '@/shared/lib';
import type { ExchangeAsset } from '../model/types';
import { NUMERIC_CONFIG } from '@/shared/config';

type Props = {
  setAmountToPay: (amount: string) => void;
  recalculateAmountToReceive: (amount: string) => void;
  assetToPay: ExchangeAsset;
};

const exchangeScreenStyles = tv({
  slots: {
    percentageButtons: 'flex flex-wrap gap-[1.6rem] justify-between',
    percentageButton: 'rounded-full headline4 w-[7rem] flex-1',
  },
});

const ExchangePercentageSection = ({
  setAmountToPay,
  recalculateAmountToReceive,
  assetToPay,
}: Props) => {
  const { percentageButtons, percentageButton } = exchangeScreenStyles();

  const exchangePercentage = useMemo(() => {
    return [
      {
        title: '25%',
        multiplier: 0.25,
      },
      {
        title: '50%',
        multiplier: 0.5,
      },
      {
        title: '75%',
        multiplier: 0.75,
      },
      {
        title: '100%',
        multiplier: 1,
      },
    ];
  }, []);

  return (
    <div className={percentageButtons()}>
      {exchangePercentage.map(percentage => (
        <Button
          key={percentage.title}
          type="button"
          variant="secondary"
          size="small"
          className={percentageButton()}
          onClick={() => {
            const amount = applyAmountPrecision(
              (assetToPay.available ?? 0) * percentage.multiplier,
              assetToPay.precision ?? NUMERIC_CONFIG.precision.default,
              'credit'
            );
            setAmountToPay(String(amount));
            recalculateAmountToReceive(String(amount));
          }}>
          {percentage.title}
        </Button>
      ))}
    </div>
  );
};

export { ExchangePercentageSection };
